const REACT_APP_URL_LOCAL = process.env.REACT_APP_URL_LOCAL;

export const information = {

  adminurl_thai_789bet: ["admin-thai789bet.freecodevip.org"],


  adminurl_thai_jun88k36: ["admin-thaijun88k36.freecodevip.org", "http://localhost:1551", "http://localhost:3001"],


  api_thai_789bet: "https://api-code-thai789bet.freecodevip.org",
  api_thai_jun88k36: "https://api-code-thaijun88k36.freecodevip.org",


  
  // api_thai_789bet: "http://localhost:5039",
  api_local: REACT_APP_URL_LOCAL,
  // site_local: "thai_789bet",
  site_local: "thai_jun88k36",

};
